// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__24Cfi","location":"Header_location__1rUlt"};